import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100vh',
    padding: '40px 24px',
    background:
      'radial-gradient(circle at top left, rgba(14,165,233,0.18), transparent 28%), radial-gradient(circle at bottom right, rgba(59,130,246,0.14), transparent 24%), linear-gradient(180deg, #f5fbff 0%, #eef5ff 52%, #ffffff 100%)',
  },
  shell: {
    maxWidth: 1180,
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'minmax(320px, 1.05fr) minmax(360px, 0.95fr)',
    gap: 32,
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 20,
    },
  },
  hero: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 32,
    minHeight: 640,
    padding: '36px 36px 32px',
    color: '#eff9ff',
    background:
      'linear-gradient(140deg, #0369a1 0%, #0891b2 34%, #0ea5e9 72%, #38bdf8 100%)',
    boxShadow: '0 28px 60px rgba(2, 132, 199, 0.24)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
      padding: '28px 24px',
    },
  },
  glowOne: {
    position: 'absolute',
    top: -80,
    right: -40,
    width: 220,
    height: 220,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.14)',
    filter: 'blur(6px)',
  },
  glowTwo: {
    position: 'absolute',
    bottom: -70,
    left: -50,
    width: 240,
    height: 240,
    borderRadius: '50%',
    background: 'rgba(12, 74, 110, 0.20)',
  },
  heroContent: {
    position: 'relative',
    zIndex: 1,
  },
  eyebrow: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    opacity: 0.88,
  },
  brandRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    marginTop: 18,
  },
  brandMark: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 54,
    height: 54,
    borderRadius: 18,
    background: 'rgba(255,255,255,0.16)',
    backdropFilter: 'blur(8px)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.18)',
    '& img': {
      width: 30,
      height: 30,
      objectFit: 'contain',
    },
  },
  brandText: {
    fontSize: 30,
    fontWeight: 700,
    letterSpacing: '-0.04em',
    lineHeight: 1.1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
    },
  },
  heroTitle: {
    marginTop: 28,
    fontSize: 44,
    lineHeight: 1.06,
    letterSpacing: '-0.05em',
    fontWeight: 700,
    maxWidth: 520,
    [theme.breakpoints.down('sm')]: {
      fontSize: 34,
    },
  },
  heroSubtitle: {
    marginTop: 18,
    maxWidth: 510,
    fontSize: 16,
    lineHeight: 1.75,
    color: 'rgba(239, 249, 255, 0.88)',
  },
  badgeGrid: {
    marginTop: 32,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 14,
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  badgeCard: {
    borderRadius: 20,
    padding: '16px 18px',
    background: 'rgba(255,255,255,0.14)',
    backdropFilter: 'blur(12px)',
    border: '1px solid rgba(255,255,255,0.14)',
  },
  badgeLabel: {
    fontSize: 10,
    textTransform: 'uppercase',
    letterSpacing: '0.22em',
    opacity: 0.78,
  },
  badgeValue: {
    marginTop: 8,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  badgeHint: {
    marginTop: 8,
    fontSize: 13,
    lineHeight: 1.6,
    color: 'rgba(239, 249, 255, 0.82)',
  },
  quotePanel: {
    position: 'relative',
    zIndex: 1,
    marginTop: 32,
    borderRadius: 24,
    padding: '20px 22px',
    background: 'rgba(8, 47, 73, 0.26)',
    border: '1px solid rgba(255,255,255,0.12)',
  },
  quoteTitle: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    opacity: 0.82,
  },
  quoteBody: {
    marginTop: 10,
    fontSize: 15,
    lineHeight: 1.7,
    color: 'rgba(239, 249, 255, 0.88)',
  },
  formWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
  },
  formCard: {
    borderRadius: 32,
    background: 'rgba(255,255,255,0.92)',
    border: '1px solid rgba(203,213,225,0.9)',
    boxShadow: '0 24px 64px rgba(15, 23, 42, 0.12)',
    padding: '30px 30px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 20px',
    },
  },
  formEyebrow: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.24em',
    textTransform: 'uppercase',
    color: '#0891b2',
  },
  formTitle: {
    marginTop: 12,
    fontSize: 32,
    lineHeight: 1.12,
    letterSpacing: '-0.04em',
    color: '#0f172a',
    fontWeight: 700,
  },
  formSubtitle: {
    marginTop: 12,
    fontSize: 14,
    lineHeight: 1.7,
    color: '#475569',
  },
  childrenWrap: {
    marginTop: 22,
  },
  footerCard: {
    borderRadius: 22,
    background: 'rgba(255,255,255,0.9)',
    border: '1px solid rgba(203,213,225,0.85)',
    boxShadow: '0 18px 44px rgba(15, 23, 42, 0.08)',
    padding: '16px 20px',
    textAlign: 'center',
    color: '#475569',
    fontSize: 14,
    lineHeight: 1.6,
  },
  footerAction: {
    color: '#0369a1',
    fontWeight: 700,
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'none',
    '&:hover': {
      color: '#075985',
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      textDecoration: 'underline',
    },
  },
}));

const AuthShell = ({
  eyebrow,
  heroTitle,
  heroSubtitle,
  heroBadges = [],
  heroQuoteTitle,
  heroQuoteBody,
  formEyebrow,
  formTitle,
  formSubtitle,
  footerPrompt,
  footerActionLabel,
  onFooterAction,
  canonicalPath = '',
  robotsContent = '',
  pageTitle = '',
  children,
}) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const previousTitle = document.title;
    const head = document.head || document.getElementsByTagName('head')[0];
    let canonicalLink = head.querySelector('link[data-auth-shell-canonical="true"]');
    let robotsMeta = head.querySelector('meta[data-auth-shell-robots="true"]');

    if (pageTitle) {
      document.title = pageTitle;
    }

    if (canonicalPath) {
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        canonicalLink.setAttribute('data-auth-shell-canonical', 'true');
        head.appendChild(canonicalLink);
      }

      const canonicalUrl = new URL(canonicalPath, window.location.origin).toString();
      canonicalLink.setAttribute('href', canonicalUrl);
    }

    if (robotsContent) {
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.setAttribute('name', 'robots');
        robotsMeta.setAttribute('data-auth-shell-robots', 'true');
        head.appendChild(robotsMeta);
      }

      robotsMeta.setAttribute('content', robotsContent);
    }

    return () => {
      document.title = previousTitle;
      if (canonicalLink && canonicalLink.parentNode) {
        canonicalLink.parentNode.removeChild(canonicalLink);
      }
      if (robotsMeta && robotsMeta.parentNode) {
        robotsMeta.parentNode.removeChild(robotsMeta);
      }
    };
  }, [canonicalPath, pageTitle, robotsContent]);

  const handleFooterKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onFooterAction();
    }
  };

  return (
    <div className={classes.page}>
      <div className={classes.shell}>
        <section className={classes.hero}>
          <div className={classes.glowOne} />
          <div className={classes.glowTwo} />

          <div className={classes.heroContent}>
            <div className={classes.eyebrow}>{eyebrow}</div>

            <div className={classes.brandRow}>
              <div className={classes.brandMark}>
                <img src="myjobaide.png" alt="MyJobAide" />
              </div>
              <div className={classes.brandText}>MyJobAide</div>
            </div>

            <div className={classes.heroTitle}>{heroTitle}</div>
            <div className={classes.heroSubtitle}>{heroSubtitle}</div>

            <div className={classes.badgeGrid}>
              {heroBadges.map((badge) => (
                <div key={badge.label} className={classes.badgeCard}>
                  <div className={classes.badgeLabel}>{badge.label}</div>
                  <div className={classes.badgeValue}>{badge.value}</div>
                  {badge.hint ? <div className={classes.badgeHint}>{badge.hint}</div> : null}
                </div>
              ))}
            </div>
          </div>

          <div className={classes.quotePanel}>
            <div className={classes.quoteTitle}>{heroQuoteTitle}</div>
            <div className={classes.quoteBody}>{heroQuoteBody}</div>
          </div>
        </section>

        <div className={classes.formWrap}>
          <section className={classes.formCard}>
            <div className={classes.formEyebrow}>{formEyebrow}</div>
            <div className={classes.formTitle}>{formTitle}</div>
            <div className={classes.formSubtitle}>{formSubtitle}</div>
            <div className={classes.childrenWrap}>{children}</div>
          </section>

          <div className={classes.footerCard}>
            {footerPrompt}{' '}
            <span
              className={classes.footerAction}
              onClick={onFooterAction}
              role="button"
              tabIndex={0}
              onKeyDown={handleFooterKeyDown}
            >
              {footerActionLabel}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
